import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppComponent } from "./app.component";
import { NavMenuComponent } from "./nav-menu/nav-menu.component";

//Modules
import { JobsModule } from "./jobs/jobs.module";
import { Employment101Module } from "./employment101/employment101.module";
import { CareersModule } from "./careers/careers.module";
import { ProfileModule } from "./profile/profile.module";
import { TrainingModule } from "./training/training.module";
import { TrainingProgramModule } from './trainingprogram/trainingprogram.module';

import { SharedModule } from "./shared/shared.module";
import { ToastrModule } from "ngx-toastr";

import { AuthGuard } from "./shared/services/AuthGuard.service";
import { UsersService } from "./shared/services/users.service";
import { CommonService } from "./shared/services/common.service";
import { RoleGuard } from "./shared/services/roleGuard.service";

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), // ToastrModule added
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    JobsModule,
    Employment101Module,
    TrainingProgramModule,
    ProfileModule,
    CareersModule,
    TrainingModule,
    RouterModule.forRoot([
      //{ path: '', component: HomeComponent, pathMatch: 'full', canActivate: [AuthGuard] },
    ])
  ],
  declarations: [
    AppComponent,
    NavMenuComponent
  ],
  exports: [

  ],
  providers: [AuthGuard, RoleGuard, UsersService, CommonService],
  bootstrap: [AppComponent]
})
export class AppModule { }
